(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports', 'react', 'clamp', './Lens'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('clamp'), require('./Lens'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.clamp, global.Lens);
        global.LensTop = mod.exports;
    }
})(this, function (exports, _react, _clamp, _Lens) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _clamp2 = _interopRequireDefault(_clamp);

    var _Lens2 = _interopRequireDefault(_Lens);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var LensTop = function LensTop(_ref) {
        var cursorOffset = _ref.cursorOffset,
            position = _ref.position,
            fadeDurationInMs = _ref.fadeDurationInMs,
            isHovering = _ref.isHovering,
            smallImage = _ref.smallImage,
            style = _ref.style;


        var maxHeight = smallImage.height - cursorOffset.y * 2;
        var height = (0, _clamp2.default)(position.y - cursorOffset.y, 0, maxHeight);
        var computedStyle = {
            height: height + 'px',
            width: '100%',
            top: '0px'
        };

        return _react2.default.createElement(_Lens2.default, {
            fadeDurationInMs: fadeDurationInMs,
            isHovering: isHovering,
            style: Object.assign({}, style, computedStyle)
        });
    };

    exports.default = LensTop;
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-image-magnify/dist/LensTop.js
 ** module id = 1102
 ** module chunks = 0
 **/